import { useParams } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { useLessonV2 } from '@/lib/lesson-v2/api';
import { LessonEditorV2 } from '@/features/lesson-editor-v2';

export function TutorAdminLessonEditV2Page() {
  const { lessonId } = useParams({ strict: false }) as { lessonId: string };
  const { data, isPending } = useLessonV2(lessonId);

  return (
    <div className="pb-safe min-h-screen bg-slate-50">
      <header className="sticky top-0 z-10 border-b border-slate-200 bg-white/95 backdrop-blur">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-3 py-3 sm:px-6">
          <a
            href={`/tutor/admin/lessons/${lessonId}`}
            className="inline-flex min-h-11 items-center gap-1 rounded-md px-2 text-sm text-slate-700 hover:bg-slate-100 active:scale-[0.98]"
          >
            <ArrowLeft className="h-4 w-4" />
            <span className="hidden sm:inline">Retour</span>
          </a>
          <h1 className="truncate text-sm font-semibold text-slate-800 sm:text-base">
            {isPending ? 'Chargement…' : (data?.meta.title ?? 'Leçon')}
          </h1>
          <span
            className={`rounded-md px-2 py-0.5 text-[10px] font-medium ${
              data?.meta.content_version === 'v2'
                ? 'bg-emerald-100 text-emerald-800'
                : 'bg-amber-100 text-amber-800'
            }`}
          >
            {data?.meta.content_version === 'v2' ? 'V2' : 'V1'}
          </span>
        </div>
      </header>
      <main>
        <LessonEditorV2 lessonId={lessonId} />
      </main>
    </div>
  );
}
